import React, { useState, useRef } from 'react';
import * as Yup from 'yup';
import LoginForm from './LoginForm';
import { checkValidNumber } from '../../../../utils/utils';
import {
  getPhoneNumber,
  getReferralCode,
  resetValue,
  isReferalModal,
  checkMobileFieldFocus,
  onChangeCheckbox,
} from './actionLogin';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import {
  removeAuthToken,
  removeSource,
  setReferalCode,
} from '../../../../utils/localStorage';
import MessageDialogBox from '../../../../shared/messageDialogBox';
import { logFirebaseEvent } from '../../firebase';
import {
  P2P_LOGIN_BTN_CLICK,
  P2P_REFER_EARN_BTN,
} from '../../firebase/constant';

const Login = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [type, setType] = useState<string>('');
  const [phone, setPhone] = useState<string>('');
  const history = useHistory();
  const dispatch = useDispatch();
  const formikRef: any = useRef();
  const [userError, setUserError] = useState(false);
  const {
    status,
    error,
    isLoading,
    referralCode,
    referalModal,
    isFocus,
    checkBoxValue,
  } = useSelector((state: any) => state.login);
  const urlParams = new URLSearchParams(window.location.search);
  var getReferalId: any = urlParams.get('ref');

  React.useEffect(() => {
    if (getReferalId) {
      try {
        setReferalCode(getReferalId);
        dispatch(getReferralCode(getReferalId));
        dispatch(isReferalModal());
      } catch (error: any) {}
    }
    document.title = 'stashearn - login';
  }, []);

  React.useEffect(() => {
    removeAuthToken();
    removeSource('source');
    if (status) {
      if (Object.values(status.results).length > 0) {
        history.push('/p2p/verifyOtp');
        dispatch(resetValue());
        setUserError(false);
      } else {
        setUserError(true);
      }
    }
  }, [status]);

  const initialValues = {
    phone: '',
  };

  const validationSchema = () =>
    Yup.object().shape({
      phone: Yup.string()
        .required('*Required')
        .test(
          'phone-check',
          'Invalid mobile number (start with 6, 7, 8, 9)',
          (value) => checkValidNumber(value ? value : '')
        )
        .max(10, 'Please enter a valid number')
        .min(10, 'Please enter a valid number'),
    });

  const onSubmitHandle = (value: any) => {
    logFirebaseEvent(P2P_LOGIN_BTN_CLICK);
    const data = {
      phone: value.phone.replaceAll(' ', ''),
    };
    if (checkBoxValue) {
      dispatch(getPhoneNumber(data));
    }
  };

  const formatPhone = (value: string, previousValue: string): any => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;
    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `${currentValue.slice(0, 3)} ${currentValue.slice(3)}`;
      return `${currentValue.slice(0, 3)} ${currentValue.slice(
        3,
        6
      )} ${currentValue.slice(6, 10)}`;
    }
  };

  const onPhoneChange = (value: string) => {
    if (value.length > initialValues.phone.length) {
      // const phoneFormatted: string = formatPhone(value, initialValues.phone);
      setPhone(value);
    } else {
      setPhone(value);
    }
    if (error) return dispatch(resetValue());
  };

  const onChangeReferral = (e: any) => {
    dispatch(getReferralCode(e.target.value));
  };

  const onClickReferalModal = () => {
    // setType('promoCode');
    // setOpen(!open);
    logFirebaseEvent(P2P_REFER_EARN_BTN);
    dispatch(isReferalModal());
  };

  const onClickNext = () => {
    setReferalCode(referralCode);
    dispatch(isReferalModal());
  };

  const checkFocus = (isFocused: boolean) => {
    dispatch(checkMobileFieldFocus(isFocused));
  };

  const handleChangeCheckbox = () => {
    dispatch(onChangeCheckbox(!checkBoxValue));
  };

  const handleClose = () => {
    setOpen(!open);
    setType('');
  };

  const enterKeyPress = (e: any) => {
    if (e.key === 'Enter') {
      if (formikRef?.current?.isValid) {
        onSubmitHandle(formikRef.current.values);
      }
    }
  };

  return (
    <>
      <LoginForm
        initialValues={initialValues}
        onSubmitHandle={onSubmitHandle}
        validationSchema={validationSchema}
        error={error}
        isLoading={isLoading}
        onPhoneChange={onPhoneChange}
        referralCode={referralCode}
        onChangeReferral={onChangeReferral}
        onClickReferalModal={onClickReferalModal}
        referalModal={referalModal}
        onClickNext={onClickNext}
        checkFocus={checkFocus}
        isFocus={isFocus}
        checkBoxValue={checkBoxValue}
        handleChangeCheckbox={handleChangeCheckbox}
        userError={userError}
        setUserError={setUserError}
        formikRef={formikRef}
        enterKeyPress={enterKeyPress}
      />
      <MessageDialogBox type={type} toggle={open} handleClose={handleClose} />
    </>
  );
};
export default Login;
